<template>
    <div class="wraper" @click.capture="(e) => checkAuthentice(e, {isMtCheck: true})">
        <div class="lawyer-content-info">
            <div
                v-if="
                    showExpire &&
                        accountInfo.vip_info &&
                        +accountInfo.vip_info.vipExpire === 2
                "
                class="vip-end-tip"
            >
                <div>
                    <veui-icon
                        class="tip-icon"
                        name="exclamation-circle-solid"
                    />
                    您的会员已过期,认领内容将在7日保护期后自动释放,为了不影响使用,请尽快重新绑定会员码
                    <span class="vip" @click="jumplawservice">绑定会员</span>
                </div>
                <div @click="closeShowExpire">
                    <veui-icon class="close" name="times"/>
                </div>
            </div>
            <div class="header-box">
                <div class="header-left">
                    <div>内容认领广场</div>
                </div>
                <div
                    v-if="receivedInfo.enable_content"
                    class="header-right"
                >
                    <div
                        class="lawyer-operate-box"
                    >
                        <div class="desc-box">
                            <div class="icon"></div>
                            <div class="desc">律所已授权，可切换使用</div>
                        </div>
                        <veui-select
                            v-model="benifitType"
                            class="benifit-transfer-box"
                            :options="benifitList"
                            @change="benifitChange"
                        />
                    </div>
                </div>
            </div>
            <div
                :class="['basic-info-box', +benifitType === 2 ? 'firm-info-box' : 'lawyer-info-box']"
            >
                <template
                    v-for="item,index in basicInfo"
                >
                    <div
                        :key="index"
                        class="basic-info-item"
                    >
                        <div class="basic-info-title">
                            <div class="desc">{{ item.title }}</div>
                            <div
                                v-if="item.tips"
                                :ref="'helpTip' + index"
                                class="tip-box"
                            >
                                <img
                                    class="icon"
                                    src="https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/tips-icon-grey.png"
                                />
                                <veui-popover
                                    :target="'helpTip' + index"
                                >
                                    {{ item.tips }}
                                </veui-popover>
                            </div>
                        </div>
                        <div class="num">{{ receivedInfo[item.key] || 0 }}</div>
                    </div>
                    <div
                        v-if="index < basicInfo.length - 1"
                        :key="index * 10 + 150"
                        class="empty-box"
                    >
                        <div class="line"></div>
                    </div>
                </template>
            </div>
            <!-- 免费体验会员 banner -->
            <freeVipBanner
                v-if="authenticationStatus === 7"
                sub-title="获得平台优质法律内容署名权，简单高效获取搜索流量，再也不用辛苦写文章了"
            />
        </div>
        <div class="banner"></div>
        <div class="content">
            <article>
                <veui-tabs
                    ui="l" :active="active"
                    @change="tabsChange"
                >
                    <veui-tab label="认领公海" name="vipBuyContentlist"/>
                    <veui-tab label="已认领" name="vipMyContentlist"/>
                    <veui-tab
                        v-if="+benifitType === 1"
                        name="vipExpireContentlist"
                    >
                        <template slot="label">
                            <span>已过期</span>
                            <veui-icon
                                ref="vipExpireContentlist"
                                class="tip-icon"
                                name="exclamation-circle-solid"
                            />
                            <veui-popover
                                target="vipExpireContentlist"
                                position="bottom-center"
                            >
                                <span class="help-text">
                                    {{ expireTip }}
                                </span>
                            </veui-popover>
                        </template>
                    </veui-tab>
                </veui-tabs>
            </article>
            <div class="square">
                <div class="fillter">
                    <veui-form
                        ref="form2"
                        class="form-box"
                        :data="formData"
                        @submit="searchContent"
                    >
                        <veui-field
                            v-if="active === 'vipExpireContentlist'"
                            label="绑定状态"
                            field="bindStatus"
                            name="bindStatus"
                        >
                            <veui-select
                                v-model="formData.bindStatus"
                                clearable
                                placeholder="请选择绑定状态"
                                overlay-class="law-question-select"
                                :options="bindOptions"
                            />
                        </veui-field>
                        <veui-field
                            v-else
                            label="选择领域"
                            field="domainId"
                            name="domainId"
                        >
                            <veui-select
                                v-model="formData.domainId"
                                clearable
                                overlay-class="law-question-select"
                                placeholder="请选择领域"
                                :options="areaOptions"
                            />
                        </veui-field>
                        <!-- <veui-field
                            label="关键词"
                            field="keyword"
                            name="keyword"
                        >
                            <veui-search-box
                                v-model="formData.keyword"
                                placeholder="请输入法律关键词"
                            />
                        </veui-field> -->
                        <veui-button
                            ui="primary" type="submit"
                            class="search"
                        >
                            查询
                        </veui-button>
                    </veui-form>
                </div>
                <div class="table-box">
                    <veui-table
                        :data="contentList"
                        key-field="id"
                    >
                        <veui-table-column
                            field="content_detail"
                            title="认领内容"
                            width="864"
                        >
                            <template #default="{content_title, content_category_name, content_detail, claim_time}">
                                <div class="content-detail-info-box">
                                    <div class="content-title">{{ content_title }}</div>
                                    <!--bca-disable-->
                                    <div class="content-detail">
                                        <text-ui
                                            :text="content_detail"
                                            :width="854"
                                            :is-pop="false"
                                            :style-info="{
                                                expandBtnBottom: '-28',
                                            }"
                                        ></text-ui>
                                    </div>
                                    <!--bca-enable-->
                                    <div class="content-footer">
                                        <div
                                            v-if="content_category_name"
                                            class="category-name"
                                        >
                                            <span
                                                v-for="tag in content_category_name.split(',')"
                                                :key="tag"
                                                class="tag"
                                            >{{ tag }}</span>
                                        </div>
                                        <div class="time">{{ claim_time | dateFilter }}</div>
                                    </div>
                                </div>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="operation"
                            title="操作"
                            align="center"
                            width="120"
                            fixed="right"
                        >
                            <template #default="{expire_claim_status, id}">
                                <div v-if="active === 'vipExpireContentlist'">
                                    <span
                                        v-if="expire_claim_status === 2"
                                        class="not-use"
                                    >
                                        已被认领
                                    </span>
                                    <veui-button
                                        v-if="
                                            expire_claim_status === 1 &&
                                                accountInfo.vip_info &&
                                                +accountInfo.vip_info.vipExpire === 1
                                        "
                                        class="operation-btn"
                                        ui="text"
                                        @click="openPopup(id)"
                                    >
                                        <span>重新认领</span>
                                    </veui-button>
                                    <span
                                        v-if="
                                            expire_claim_status === 1 &&
                                                accountInfo.vip_info &&
                                                +accountInfo.vip_info.vipExpire !== 1
                                        "
                                        class="not-use"
                                    >
                                        待认领
                                    </span>
                                </div>
                                <veui-button
                                    v-else
                                    ui="text"
                                    class="operation-btn"
                                    @click="openPopup(id)"
                                >
                                    <span
                                        v-if="active === 'vipMyContentlist'"
                                        class="cancel"
                                    >取消认领</span>
                                    <span
                                        v-else
                                        class="claim"
                                    >认领</span>
                                </veui-button>
                            </template>
                        </veui-table-column>
                        <template #no-data>
                            <div class="blank">
                                <div class="icon"></div>
                                <div class="text">暂无数据</div>
                            </div>
                        </template>
                    </veui-table>
                </div>
            </div>
            <div v-if="active === 'vipBuyContentlist'" class="pagination">
                <veui-button
                    ui="primary"
                    class="margin-right-normul"
                    :disabled="page.pn === 1"
                    @click="pageChange(page.pn - 1)"
                >
                    上一页
                </veui-button>
                <veui-button
                    ui="primary"
                    :disabled="!hasnext"
                    @click="pageChange(page.pn + 1)"
                >
                    下一页
                </veui-button>
            </div>
            <veui-pagination
                v-else-if="page.total"
                class="pagination"
                :page="page.pn"
                :page-size="page.rn"
                :total="page.total"
                @redirect="pageChange"
            />
            <veui-dialog
                ui="narrow"
                :open.sync="confirmClaim"
                :footless="true"
                overlay-class="order-management-dialog"
            >
                <template #title>
                    {{
                        active === "vipMyContentlist"
                            ? "确认解除认领"
                            : "确认认领"
                    }}
                </template>
                <template v-if="active === 'vipMyContentlist'">
                    <p style="margin-bottom: 24px;">
                        您即将解除改问答内容的认领关系，解除后，您的认领权益会+1，您确认解除吗？
                    </p>
                    <veui-button ui="primary" @click="claimFn('cancel')">
                        确认解除
                    </veui-button>
                    <veui-button
                        class="cancel-btn"
                        @click="confirmClaim = false"
                    >
                        我再想想
                    </veui-button>
                    <div class="cancel-cluim-tip">
                        您有效期内已使用{{
                            receivedInfo.release_used
                        }}次取消权益,还剩余{{ receivedInfo.release_remain }}次
                    </div>
                </template>
                <template v-else>
                    <p>
                        确认后将消耗一次会员周期的认领次数,确定要认领该内容吗?
                    </p>
                    <div class="cluim-number">
                        您当前认领次数还剩:<span>{{
                            receivedInfo.claim_remain
                        }}</span>条
                    </div>
                    <veui-button
                        :ui="formData.term ? 'm primary' : 'm'"
                        @click="claimFn('claim')"
                    >
                        确认
                    </veui-button>
                    <div class="claim-agreement">
                        <veui-checkbox v-model="formData.term">
                            我已阅读并接受
                        </veui-checkbox>
                        <span
                            class="agreement" @click.stop="openBuyRule"
                        >《内容认领规则》</span>
                    </div>
                </template>
            </veui-dialog>
            <veui-dialog
                ui="narrow"
                :open.sync="showErrorModal"
                overlay-class="order-management-dialog"
            >
                <template #title>
                    {{
                        active === "vipMyContentlist"
                            ? "确认解除认领"
                            : "认领失败"
                    }}
                </template>
                <p v-if="active === 'vipMyContentlist'">
                    您本次认领周期内的取消认领权益次数已用尽,如有疑问可邮件lvlin_help@baidu.com
                </p>
                <p v-else>
                    {{ +benifitType === 2 ? '律所内容额度已全部被消耗，请切换为个人版权益' : '抱歉您的认领次数已经用完,暂时无法认领内容' }}
                </p>
                <template #foot>
                    <veui-button ui="m primary" @click="showErrorModal = false">
                        我知道了
                    </veui-button>
                </template>
            </veui-dialog>
        </div>
        <veui-dialog
            ui="narrow"
            title=""
            :open.sync="ShowNoMemberModal"
            overlay-class="order-management-dialog"
        >
            <p>
                您还不是{{ noMemberModalText[0] }},无法使用认领功能,点击“{{ noMemberModalText[1] }}”,即刻享受线索认领和内容认领权益
            </p>
            <template #foot>
                <veui-button ui="m primary" @click="jumplawservice">
                    {{ noMemberModalText[2] }}
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
import {
    Popover,
    Tabs,
    Tab,
    Form,
    Field,
    Button,
    Select,
    Pagination,
    Icon,
    Dialog,
    Table,
    Column,
    Checkbox
} from 'veui';
import {mapState, mapMutations} from 'vuex';
import mixinauthentice from '@/mixins/authentice';
import get from 'lodash/get';
import dayjs from 'dayjs';
import freeVipBanner from '@/components/vip/free-vip-banner.vue';
import TextUi from '../../../components/text-html-ui';

/**
 * @file index.vue
 * @author sunhemeng
 * @desc 线索公海
 */
const url = {
    // 消息列表
    vipBuyIndex: '/bp/api/content/index',
    // 公海
    vipBuyContentlist: '/bp/api/business/publiccontentlist',
    // 已认领列表
    vipMyContentlist: '/bp/api/content/claimlist',
    // 已过期
    vipExpireContentlist: '/bp/api/content/expirecontentlist',
    // 认领
    vipClaimContent: '/bp/api/content/claim',
    // 取消认领
    vipCancelContent: '/bp/api/content/release',
    // 领域查询
    getDomains: '/bp/api/content/domains'
};
export default {
    name: 'lawclues',
    mixins: [mixinauthentice],
    components: {
        'veui-popover': Popover,
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        'veui-form': Form,
        'veui-field': Field,
        'veui-select': Select,
        'veui-table': Table,
        'veui-table-column': Column,
        // 'veui-search-box': SearchBox,
        'veui-button': Button,
        'veui-pagination': Pagination,
        'veui-icon': Icon,
        'veui-dialog': Dialog,
        'veui-checkbox': Checkbox,
        'text-ui': TextUi,
        freeVipBanner
    },
    filters: {
        dateFilter(value) {
            if (!value) {
                return '-';
            }
            return dayjs(value).format('YYYY.MM.DD HH:mm:ss');
        }
    },
    computed: {
        ...mapState({
            vipInfo: state => state.lawStore.vipInfo,
            userInfoNew: state => state.lawStore.userInfoNew,
            authenticationStatus: state => state.lawStore.authenticationStatus,
            businessId: state => state.lawStore.userInfoNew?.lawyer_info?.business_id || ''
        }),
        freeVipNotification() {
            const {vipStatusName, validityEnd} = this.vipInfo;
            const {claim_remain} = this.receivedInfo;
            const remainDays = dayjs(validityEnd).diff(dayjs(), 'days');
            if (vipStatusName === 'freeVip') {
                return claim_remain
                    ? `您的免费体验会员还有${remainDays}天到期，您还剩余${claim_remain}次权益余额，请尽快使用~`
                    : '您的免费认领次数已用尽，联系客服开通正式会员享受完整权益~';
            }
            return '';
        },
        // 律师、律所-大盘数据
        basicInfo() {
            return +this.benifitType === 2 ? this.firmBasicInfoList : this.lawyerBasicInfoList;
        }
    },
    data() {
        return {
            hasnext: false,
            active: 'vipBuyContentlist',
            isModify: false,
            receivedInfo: {
                claim_remain: 0,
                expire_cnt: 0,
                release_remain: 0,
                total_cnt: 0,
                release_used: 0,
                claim_limit: 0,
                // 律所是否授权
                enable_content: 0
            },
            formData: {
                domainId: null,
                // keyword: '',
                term: false,
                bindStatus: null
            },
            areaOptions: [],
            contentList: [],
            bindOptions: [
                {label: '待认领', value: '1'},
                {label: '已被认领', value: '2'}
            ],
            page: {
                pn: 1,
                rn: 10,
                total: 0
            },
            confirmClaim: false,
            accountInfo: {},
            curContentId: '',
            showErrorModal: false,
            ShowNoMemberModal: false,
            noMemberModalText: ['律临VIP会员', '成为会员', '成为会员'],
            showExpire: true,
            expireTip:
                '当年会员权益到期后，若7天内没有重新绑定会员，则认领内容变为“已过期”，同时认领状态变更为“待认领”，“已过期”的内容的状态若显示为"已认领“，则表示该内容被其他律师认领。',
            benifitList: [
                {
                    label: '个人版权益',
                    value: 1
                },
                {
                    label: '律所版权益',
                    value: 2
                }
            ],
            // 权益类型
            benifitType: 1,
            // 律师-基础信息
            lawyerBasicInfoList: [
                {
                    title: '个人权益可认领数',
                    tips: '当前会员周期内可以认领的内容总数，当前默认120条',
                    key: 'claim_remain'
                },
                {
                    title: '已认领内容数',
                    tips: '当前会员周期内已认领的内容个数',
                    key: 'total_cnt'
                },
                {
                    title: '可修改认领次数',
                    tips: '当前会员周期内可解除认领的内容个数',
                    key: 'release_remain'
                },
                {
                    title: '已过期认领条数',
                    tips: '会员到期后，7天内没有续费，导致前一个会员周期内认领成功的内容条数成为过期状态，过期的内容条数为已过期认领条数',
                    key: 'expire_cnt'
                }
            ],
            // 律所-基础信息
            firmBasicInfoList: [
                {
                    title: '可认领额度',
                    tips: '律所授权的可认领的内容总数',
                    key: 'claim_limit'
                },
                {
                    title: '剩余可认领数',
                    tips: '律所授权的剩余可认领的内容个数',
                    key: 'claim_remain'
                },
                {
                    title: '累计认领数',
                    tips: '律所授权的累计认领的内容数',
                    key: 'total_cnt'
                },
                {
                    title: '可修改认领次数',
                    tips: '当前会员周期内可解除认领的内容个数',
                    key: 'release_remain'
                }
            ]
        };
    },
    watch: {
        vipInfo: {
            handler() {
                this.getData();
            },
            deep: true
        }
    },
    created() {
        this.getData();
        this.getContentList();
        this.getDomains();
    },
    methods: {
        ...mapMutations({
            emitEvent: 'EventBus/emitEvent'
        }),
        getData() {
            this.getAccountInfo();
            this.getPageInfo();
        },
        getAccountInfo() {
            this.$http.get('/bp/api/account/info')
                .then(res => {
                    const accountInfo = this.$normalizeResponseData(res);
                    if (accountInfo) {
                        this.accountInfo = accountInfo;
                    }
                }).catch(err => {
                    this.$normalizeResponseError(err);
                });
        },
        getPageInfo() {
            this.$http.get(url.vipBuyIndex, {
                params: {
                    business_id: this.businessId,
                    claim_type: this.benifitType
                }
            }).then(res => {
                const resp = res.data;
                if (resp) {
                    this.receivedInfo = resp;
                }
            }).catch(err => {
                this.$normalizeResponseError(err);
            });
        },
        openBuyRule() {
            window.open(
                'https://law-smartapp.cdn.bcebos.com/pdf/content-claim-rule.pdf'
            );
        },
        /**
         * 权益切换
         */

        benifitChange() {
            this.page.pn = 1;
            this.page.total = 0;
            this.active = 'vipBuyContentlist';
            this.getPageInfo();
            this.getContentList();
        },
        closeShowExpire() {
            this.showExpire = false;
        },
        searchContent() {
            this.page.pn = 1;
            this.page.total = 0;
            this.getContentList();
        },
        getContentList() {
            this.contentList = [];
            this.$http
                .get(url[this.active] || 'vipBuyContentlist', {
                    params: {
                        vn: 'law',
                        clientType: 'h5',
                        pn: this.page.pn,
                        rn: this.page.rn,
                        domain_id: this.formData.domainId || '',
                        bind_status: this.formData.bindStatus || '',
                        claim_type: this.benifitType,
                        business_id: this.businessId
                    }
                })
                .then(res => {
                    if (!res || +res.code !== 0 || !res.data) {
                        return;
                    }
                    let respData = res.data || {};
                    if (respData.total) {
                        this.page.total = respData.total;
                    }
                    this.hasnext = respData.hasnext || false;
                    this.contentList = respData.list || [];
                });
        },
        pageChange(page) {
            this.page.pn = page;
            this.getContentList();
        },
        tabsChange(e) {
            const name = e.name;
            if (name !== this.active) {
                this.active = name;
                this.page = {
                    pn: 1,
                    rn: 10,
                    total: 0
                };
                this.$refs.form2.reset();
                this.getContentList();
            }
        },
        openPopup(id) {
            const {privilege_info, vipStatus, vipStatusName} = this.vipInfo;

            // v卡会员、或启航会员：限制其线索认领功能
            if (this.benifitType === 1 && +vipStatus === 1 && ['vcardVip', 'beginnerVip'].includes(vipStatusName)) {
                this.ShowNoMemberModal = true;
                if (vipStatusName === 'beginnerVip') {
                    this.noMemberModalText = ['尊享会员', '成为尊享会员', '成为尊享会员'];
                }
                return;
            }
            // 非会员
            if (this.benifitType === 1 && !+vipStatus) {
                // 体验会员过期用户
                if (privilege_info && +privilege_info.vip_code_type === 6) {
                    this.$Message.info('您的体验会员已到期，暂不可使用');
                    return;
                }
                this.ShowNoMemberModal = true;
                return;
            }
            if (
                (this.active === 'vipMyContentlist'
                    && this.receivedInfo.release_remain > 0)
                || (this.active === 'vipBuyContentlist'
                    && this.receivedInfo.claim_remain > 0)
            ) {
                this.confirmClaim = true;
                this.curContentId = id;
            }
            else {
                this.showErrorModal = true;
            }
        },
        claimFn(type) {
            if (type === 'claim' && !this.formData.term) {
                return;
            }
            const claimUrl
                = type === 'cancel' ? url.vipCancelContent : url.vipClaimContent;
            this.$http
                .post(claimUrl, {
                    contentId: '' + this.curContentId,
                    businessId: this.businessId,
                    claim_type: this.benifitType,
                    again_claim: this.active === 'vipExpireContentlist' ? 1 : 0
                })
                .then(res => {
                    let respData = res.data || {};
                    if (+res?.code === 0) {
                        this.getContentList();
                        this.receivedInfo = {
                            ...respData,
                            enable_content: this.receivedInfo.enable_content
                        };
                        this.$Message.success(
                            type === 'cancel'
                                ? '解除成功！'
                                : '认领成功，可前往已认领列表查看！'
                        );
                    }
                    else {
                        this.$Message.error(res.msg || `${type === 'cancel' ? '解除' : ''}认领失败`);
                    }
                    this.confirmClaim = false;
                });
        },
        jumplawservice() {
            this.$router.push({name: 'lawservice'});
        },

        /**
         * 获取领域
         */

        getDomains() {
            this.$http
                .get(url.getDomains, {})
                .then(res => {
                    if (+res.code !== 0) {
                        return;
                    }
                    let data = res.data || [];
                    this.areaOptions = data.map(item => ({
                        label: item.text,
                        ...item
                    }));
                })
                .catch(err => {
                });
        }
    }
};
</script>
<style lang="less" scoped>
.margin-right-normul {
    margin-right: 10px;
}

.veui-button.veui-disabled {
    background-color: #dce9ff !important;
}

.lawyer-content-info {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    padding: 24px 30px;
    box-sizing: border-box;

    .tip-icon {
        color: #ff9100;
    }

    .vip-end-tip {
        width: 100%;
        height: 33px;
        background: #fff9f2;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #282c33;
        margin-bottom: 24px;

        .vip {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #0052cc;
            cursor: pointer;
        }

        .close {
            margin-left: 16px;
            color: #848b99;
        }

        svg {
            vertical-align: middle;
        }
    }

    .title-box {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #282c33;
        line-height: 16px;
        font-weight: 600;

        .vip-time-end {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #999;
            line-height: 14px;
            margin-left: 12px;
        }

        .free-vip-notification {
            height: 20px;
            padding: 0 8px;
            display: inline-flex;
            align-items: center;
            background-image: linear-gradient(90deg, #ffe99e 1%, #ffdc68 100%);
            border-radius: 2px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9a490e;
            font-weight: 400;

            &::before {
                content: "";
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/free-membership/icon-notification.png") no-repeat center / cover;
                width: 14px;
                height: 14px;
                margin-right: 6px;
            }
        }
    }

    .header-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-left {
            display: flex;
            align-items: center;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 600;
            line-height: 16px;
            color: #333;

            .icon {
                margin-left: 4px;
                width: 12px;
                height: 12px;
            }
        }

        .header-right {
            .lawyer-operate-box {
                display: flex;
                align-items: center;

                .desc-box {
                    display: flex;
                    align-items: center;
                    height: 16px;
                    padding: 0 8px;
                    background-color: #ffd2a0;
                    border-radius: 8px;

                    .icon {
                        width: 10px;
                        height: 10px;
                        margin-right: 4px;
                        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/content-marketing/tips-icon.png") no-repeat center;
                        background-size: cover;
                    }

                    .desc {
                        font-family: PingFang SC;
                        font-size: 10px;
                        font-weight: 400;
                        line-height: 10px;
                        color: #a54300;
                    }
                }

                .benifit-transfer-box {
                    margin-left: 14px;
                    width: 120px;
                    height: 30px;
                }
            }
        }
    }

    .basic-info-box {
        margin-top: 24px;
        display: flex;
        height: 109px;
        background-color: #f6f8f9;
        border-radius: 8px;

        &.firm-info-box {
            padding: 0 24px;

            .basic-info-item {
                padding-top: 24px;
            }
        }

        &.lawyer-info-box {
            align-items: center;
            padding: 0 62px;
        }

        .empty-box {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;

            .line {
                width: 1px;
                height: 48px;
                background: rgba(51, 51, 51, .09);
            }
        }

        .basic-info-item {
            flex-shrink: 0;

            .basic-info-title {
                display: flex;
                align-items: center;
                color: #333;

                .desc {
                    font-family: PingFang SC;
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 13px;
                }

                .icon {
                    margin-left: 4px;
                    width: 12px;
                    height: 12px;
                }
            }

            .num {
                margin-top: 8px;
                font-family: baidu number;
                font-size: 28px;
                font-weight: 500;
                line-height: 28px;
            }
        }
    }
}

.table-box {
    /deep/ .veui-table {
        table {
            min-width: 100% !important;
        }

        [role="columnheader"] {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #999;
            padding: 12px;
        }

        .veui-table-cell-select:first-child,
        .veui-table-cell-expand:first-child,
        .veui-table-cell-first {
            padding-left: 24px;
        }

        .veui-table-cell {
            height: auto !important;
            width: 100%;
            margin: 0;

            .veui-table-cell-content {
                width: 100%;
            }

            .content-detail-info-box {
                padding: 20px 80px 20px 24px;
            }

            .content-title {
                font-family: PingFang SC;
                font-size: 16px;
                font-weight: 500;
                line-height: 16px;
                color: #333;
                padding-bottom: 10px;
            }

            .content-footer {
                margin-top: 10px;
                display: flex;
                align-items: center;
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                line-height: 14px;
                color: #999;

                .category-name {
                    padding: 0 8px;
                    height: 20px;
                    line-height: 20px;
                    color: #999;
                    background-color: rgba(233, 236, 243, .5);
                    border-radius: 8px;
                    margin-right: 12px;
                }
            }

            .operation-btn {
                font-family: PingFang SC;
                font-size: 16px;
                font-weight: 400;
                line-height: 16px;
                color: #05f;

                &.disabled {
                    color: rgba(0, 85, 255, .3);
                }
            }
        }
    }

    .not-use {
        font-size: 14px;
        color: #8fbcff;
    }
}

.banner {
    margin: 24px 0;
}

.content {
    background: #fff;
    border-radius: 4px;
    padding: 16px 30px 30px;
    box-sizing: border-box;

    /deep/ .veui-tabs {
        .veui-tabs-menu {
            height: 44px;

            .veui-tabs-item {
                margin: 0 30px;
            }

            .veui-tabs-item:first-child {
                margin-left: 0;
            }

            .veui-tabs-item-label {
                font-family: PingFang SC;
                font-size: 16px;
                font-weight: 500;
                line-height: 16px;
            }
        }
    }

    /deep/ .veui-button[ui~="primary"] {
        border-color: transparent;
        width: 80px;
        background-color: #05f;
        color: #fff;
    }

    /deep/ .veui-input,
    .veui-search-box,
    .veui-select {
        width: 201px;
        height: 40px;
    }

    /deep/ .veui-field-label {
        width: 68px;
        height: 40px;
        justify-content: flex-start;
        align-items: center;
        margin-right: 0;
        box-sizing: border-box;
    }

    /deep/ .veui-field {
        margin-bottom: 16px;
    }

    /deep/ .veui-field:not(:last-child) {
        margin-right: 24px;
    }

    /deep/ .veui-button.search {
        margin-left: 0;
        width: 80px;
        height: 40px;
    }

    /deep/ .veui-table [role="cell"] {
        padding: 0;
    }

    /deep/ .tip-icon {
        color: #ff9100;
    }

    .square,
    .alreadyClaim {
        margin-top: 16px;
    }
}

.form-box {
    display: flex;

    .search {
        margin-left: -36px;
    }
}

.ivu-cascader {
    /deep/ .ivu-input {
        width: 180px;
        height: 32px;
        border: 1px solid #d3d9e6;
    }
}

.pagination {
    width: 100%;
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    padding-right: 36px;
    box-sizing: border-box;

    /deep/ .veui-pagination-info {
        display: none;
    }
}

a {
    color: #404eff;
}

a:hover {
    color: #404eff;
}

a:active {
    color: #404eff;
}

.bind-disabled {
    color: #8fbcff;
}

.cluim-number {
    min-width: 214px;
    height: 48px;
    background: #f9f9f9;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #282c33;
    line-height: 14px;
    padding: 16px 0 0 12px;
    box-sizing: border-box;
    margin: 7px 0;

    span {
        font-family: PingFangSC-Medium;
        font-size: 24px;
        color: #282c33;
        line-height: 24px;
        font-weight: 500;
        margin: 0 9px;
    }
}

.claim-agreement {
    margin-top: 12px;

    .agreement {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #404eff;
        cursor: pointer;
    }

    /deep/ .veui-checkbox {
        vertical-align: text-top;
    }
}

.cancel-cluim-tip {
    color: #ffa733;
    margin-top: 12px;
}

.not-list {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #a8b0bf;
    flex-direction: column;
}

.order-management-dialog {
    .cancel-btn {
        margin-left: 24px;
    }
}
</style>
<style lang="less">
.law-question-select .veui-select-options[ui~="m"] {
    max-height: initial;
}
</style>
